module.exports = __webpack_public_path__ + "images/img-brends3.29ba2b3a.jpg";